import "./Mentions.css";

const Mentions = () => {
    return (
        <div className="mentionsContainer">
            <div className="mentions">
                <div id="mentionsHeader">
                    <h1 className="mentionsTitle">Mentions légales</h1>
                </div>

                <div className="mentionsSubTitle">
                    <p className="mentionsSubTitlePrefix">Éditeur du site :</p>
                </div>
                <p>
                    Funeral Logistic Conseil, SAS au capital de 1 000€<br />
                    SIRET : 843172172<br />
                    TVA intracommunautaire : FR 95843172172<br />
                    Siège social : 26 Rue Tamponnet, 91210 Draveil, France
                </p>

                <div className="mentionsSubTitle">
                    <p className="mentionsSubTitlePrefix">Hébergement :</p>
                </div>
                <p>
                    OVH, 2 rue Kellermann, 59053 Roubaix<br />
                    Site web :{" "}
                    <a
                        href="https://www.ovh.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        www.ovh.com
                    </a>
                </p>

                <div className="mentionsSubTitle">
                    <p className="mentionsSubTitlePrefix">Responsabilité éditoriale :</p>
                </div>
                <p>
                    Directrice de la publication : Françoise Lavergne<br />
                    Propriété intellectuelle (textes et images) : Hugo Lavergne
                </p>
                <div className="mentionsSubTitle">
                    <p className="mentionsSubTitlePrefix">Données personnelles :</p>
                    </div>
                    <p>Les informations recueillies via le formulaire de contact (nom, adresse e-mail, message) font l'objet d’un traitement informatisé par la société Funeral Logistic Conseil, dont le siège social est sis 26 Rue Tamponnet, 91210 Draveil, France, afin de répondre aux messages envoyés par les utilisateurs.</p>
<p>La base légale du traitement est l’intérêt légitime de la société Funeral Logistic Conseil à répondre aux demandes reçues.</p>
<p>Les informations recueillis via le formulaire sont obligatoires afin de permettre à la société de traiter et répondre à votre demande. En cas de refus de communication, la société Funeral Logistic Conseil ne pourra pas répondre à votre message.  </p>
<p>Les données ainsi collectées sont conservées pendant 12 mois à compter du dernier contact avec l’utilisateur, puis supprimées</p>
<p>Vous pouvez à tout moment exercer vos droits d’accès, de rectification, d’effacement, de limitation ou d’opposition au traitement de vos données personnelles.
</p>
<p>Pour exercer ces droits ou pour toute question relative au traitement de vos données, vous pouvez contacter la société Funeral Logistic Conseil, à l’adresse postale suivante : 26 Rue Tamponnet, 91210 Draveil, France, ou par e-mail à : <a href="mailto:info@cartozinc.com" className="mentionsLink"> info@cartozinc.com</a></p>
<p> 
Si vous estimez, après nous avoir contactés, que vos droits « Informatique et Libertés » ne sont pas respectés, vous pouvez adresser une réclamation à la CNIL.
 
Pour plus d’informations sur vos droits, consultez le site de la CNIL : <a href="http://cnil.fr/" className="mentionsLink">CNIL</a></p>
<p>Ce site utilise uniquement des cookies techniques nécessaires à son bon fonctionnement. Ces cookies ne permettent pas de vous identifier personnellement, ne sont pas utilisés pour la publicité ou la mesure d’audience, et sont supprimés automatiquement à la fermeture de votre navigateur. </p>
            </div>
        </div>
    );
};

export default Mentions;